import React from 'react';
import { useTranslation } from 'react-i18next';

function HomePopularCard({ image, href, alt, badgeText, iconClass, cardClass }) {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language === 'me' ? 'me' : 'en';

  const localizedValue = (value) => {
    if (value && typeof value === 'object') {
      return value[currentLanguage] || value.en || value.me || '';
    }

    return value || '';
  };

  const localizedHref = localizedValue(href);
  const localizedAlt = localizedValue(alt);
  const localizedBadgeText = localizedValue(badgeText);

  return (
    <div className={`brand-card ${cardClass}`}>
      <div className="badge-popular position-absolute top-0 start-0 bg-warning text-dark py-1 px-3">
        {localizedBadgeText}
      </div>
      <a href={localizedHref} className="card-link" aria-label={localizedAlt}>
        <div className="image-wrapper">
          <img src={image} alt={localizedAlt} className="product-image" />
          <div className="overlay">
            <i className={iconClass + " cart-icon"}></i>
          </div>
        </div>
      </a>
    </div>
  );
}

export default HomePopularCard;
